import { useEffect, useState } from "react";
import "./EleventhReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const EleventhReport = ({res}) => {
  const [areaValue, setAreaValue] = useState("");
  const [coeValue, setCoeValue] = useState(""); // NEW

  useEffect(() => {
    const storedArea = res.area;
    if (storedArea) setAreaValue(storedArea);

    const storedCoE = res.coe
    if (storedCoE) setCoeValue(storedCoE);
  }, [res]);

  // =========== 10B Content ===========
  const areaYes =
    "Having access to a sector-specific incubation centre accelerates growth through mentorship, funding, and validation — strengthening investor confidence.";

  const areaNo =
    "You’ll proactively connect with regional or virtual incubators to access guidance, tools, and networks — ensuring readiness and investor visibility.";

  // =========== 10C Content ===========
  const coeYes =
    "Partner with that CoE for rapid prototype build, testing, and certification. Mention its name in investor deck (e.g., “In collaboration with MSME CoE Bangalore”).";

  const coeNo =
    "Collaborate virtually or regionally — contact IIT/NIC incubators, T-Hub, or private R&D labs. Apply for national innovation missions or CoE grants to access prototyping remotely.";

  return (
    <div style={{ padding: '22px' }}>
     

      <div className="eleventh-module-container">
       <h3 className="module-title"> <span className="module-prefix">Module 10:</span>  Area</h3>
        <QTag
          q="Is there a sector-specific incubation centre near you? Do you have access to a Centre of Excellence (CoE) for advanced prototyping?"
          a={`Incubation centre nearby: ${areaValue === "<Yes" ? "Yes" : "No"} · CoE access: ${coeValue === ">Yes" ? "Yes" : "No"}`}
          impacts="Ecosystem support access, prototype development speed, mentorship availability, grant eligibility"
        />
        {/* Corner Borders */}
        <span className="corner top-left"></span>
        <span className="corner top-right"></span>
        <span className="corner bottom-left"></span>
        <span className="corner bottom-right"></span>

        {/* 10 B - Incubation Centre */}
        {areaValue && (
          <table className="eleventh-module-table">
            
            <tbody>
              <tr>
                <td className="serial-cell">10 B</td>
                <td>{areaValue === "<Yes" ? "Yes" : "No"}</td>
                <td>{areaValue === "<Yes" ? areaYes : areaNo}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* ⭐ 10 C - Prototype / Advanced Tech CoE */}
        {coeValue && (
          <table className="eleventh-module-table">
            
            <tbody>
              <tr>
                <td className="serial-cell">10 C</td>
                <td>{coeValue === ">Yes" ? "Yes" : "No"}</td>
                <td>{coeValue === ">Yes" ? coeYes : coeNo}</td>
              </tr>
            </tbody>
          </table>
        )}

      </div>
    </div>
  );
};

export default EleventhReport;
